import { render, staticRenderFns } from "./Borang.vue?vue&type=template&id=85bc28a8"
import script from "./Borang.vue?vue&type=script&lang=js"
export * from "./Borang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports